import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import { InfoOutlineIcon } from '@/resources';

type OptionInfoIconProps = {
  text: string;
};

export const OptionInfoIcon = ({ text }: OptionInfoIconProps) => {
  const iconRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<{ top: number; left: number } | null>(null);

  const handleMouseEnter = () => {
    const rect = iconRef.current?.getBoundingClientRect();
    if (rect) {
      setPosition({ top: rect.top - 8, left: rect.right });
    }
  };

  return (
    <div
      ref={iconRef}
      className='ml-auto shrink-0'
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setPosition(null)}
      onClick={(e) => e.stopPropagation()}>
      <InfoOutlineIcon className='size-6 text-secondary-steel-blue' />
      {position &&
        createPortal(
          <div
            style={{ top: position.top, left: position.left }}
            className='pointer-events-none fixed z-[10000] w-48 -translate-x-full -translate-y-full text-wrap rounded-lg bg-secondary-steel-blue px-2 py-1 text-xs text-primary-white'>
            {text}
          </div>,
          document.body
        )}
    </div>
  );
};
